import { Fragment } from "react";
import { Link } from "react-router-dom";
import { faFileDownload, faExternalLinkAlt } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { AlertComponent } from "../../components";
import { isMobileDevice, REPORT_TYPES } from "../../constants";
import { EventUtils, ObjectUtils } from "../../utils";
import { useSelector } from "react-redux";
import { RootState } from "../../reducers";

export const ConfirmedItemComponent = (props: any) => {
  const { finishEnrollmentData, reportType, paramValue } = props;
  const { contentFooter } = useSelector((state: RootState) => state.common);
  const lblNewTab = ObjectUtils.extractLabelFromObject(contentFooter?.contentResource?.contents, "lblNewTab");

  const getReportClass = (reportType) => {
   if (reportType === REPORT_TYPES.EOI_FORM) {
        return 'report-text-type-2';
    } else if (reportType === REPORT_TYPES.PAD_AGREEMENT || reportType=== REPORT_TYPES.BENEFICIARY_FORM) {
        return 'report-text-type-1';
    }
    return '';
  };

  return (
    <>
      {finishEnrollmentData?.map((item: any, index: number) => {
        return (
          <Fragment key={index}>
            {item?.isexists && (
              <div>
                <AlertComponent marginleft={false} propmessageType={item?.messagetype === "DANGER" ? "danger clearfix" : " clearfix pb-3 pb-md-4"} propmessage={item?.message} />
                <div className="mb-3 item" style={{ backgroundColor: item?.backcolor }}>
                  <div className={`d-flex justify-content-between  confirmationitem "p-3"`}>
                    {item?.title && !(reportType === REPORT_TYPES.EOI_FORM || reportType === REPORT_TYPES.BENEFICIARY_FORM) && !item?.confirmationstatment && <p className="m-0">{item?.title}</p>}
                    {item?.confirmationstatment ? (
                      <div className={`d-flex justify-content-between align-items-center clickbtn ` + getReportClass(REPORT_TYPES.EOI_FORM)}>
                        {item?.reportType === REPORT_TYPES.BENEFICIARY_FORM ? <Link target={isMobileDevice ? "" : "blank"} to={`/ViewHtmlReport?reportType=${item?.reportType}&param=${item?.paramValue}`} aria-label={isMobileDevice ? "" : (item?.title + " " + lblNewTab.textToRead)} className="m-1 ps-0">
                          {item?.title}
                          <FontAwesomeIcon icon={faExternalLinkAlt} className="ms-1" />
                        </Link> :
                          <Link target={isMobileDevice ? "" : "blank"} to={`/ReviewCoverage/CurrentCoverage?${item?.parameters}`} aria-label={isMobileDevice ? "" : (item?.title + " " + lblNewTab.textToRead)} className="m-1 ps-0">
                            {item?.title}
                            <FontAwesomeIcon icon={faExternalLinkAlt} className="ms-1" />
                          </Link>}
                      </div>
                    ) :
                      (reportType === REPORT_TYPES.PAD_AGREEMENT || reportType === REPORT_TYPES.BENEFICIARY_FORM || (reportType === REPORT_TYPES.EOI_FORM && !item?.eoiFormsType)) ? <div className={`d-flex justify-content-between align-items-center clickbtn ` + getReportClass(reportType)}>
                        <Link target={isMobileDevice ? "" : "blank"}
                          to={`/ViewHtmlReport?reportType=${reportType}&param=${paramValue}`} aria-label={isMobileDevice ? "" : (reportType === REPORT_TYPES.EOI_FORM || reportType === REPORT_TYPES.BENEFICIARY_FORM ? item?.title : item?.buttontitle) + " " + lblNewTab.textToRead} className="m-1 ps-0">
                          {reportType === REPORT_TYPES.EOI_FORM || reportType === REPORT_TYPES.BENEFICIARY_FORM ? item?.title : item?.buttontitle}
                          <FontAwesomeIcon icon={faExternalLinkAlt} className="ms-1" />
                        </Link>
                      </div> : (reportType === REPORT_TYPES.EOI_FORM && item?.eoiFormsType) ?
                        <div
                          className={`d-flex justify-content-between align-items-center clickbtn ` + getReportClass(reportType)}
                          role="button"
                          aria-label={isMobileDevice ? "" : (item?.title + " " + lblNewTab.textToRead)}
                          tabIndex={0}
                          onClick={item?.navigateclicked}
                          onKeyDown={(e) => EventUtils.keyPressed(e) && item.navigateclicked(e)}
                        >
                          <p className="m-1 p-0"> {item?.title}</p>
                          <FontAwesomeIcon icon={faExternalLinkAlt} />
                        </div>
                        : (<div
                          className="d-flex justify-content-between align-items-center clickbtn"
                          role="button"
                          tabIndex={0}
                          onClick={item?.navigateclicked}
                          onKeyDown={(e) => EventUtils.keyPressed(e) && item.navigateclicked(e)}
                        >
                          <FontAwesomeIcon icon={faFileDownload} />
                          <p className="m-1 ps-2">{item?.buttontitle}</p>
                        </div>)
                    }
                  </div>
                </div>
              </div>
            )}
          </Fragment>
        );
      })}
    </>
  );
};

export default ConfirmedItemComponent;
